import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent {
	title = 'ErgoFlex';

	constructor(public translate: TranslateService,private router: Router) {
		translate.addLangs(['en', 'fr'])
		translate.setDefaultLang('en')
		const browserLang = translate.getBrowserLang()
		translate.use(browserLang.match(/en|fr/) ? browserLang : 'en')
		var pathName: string = window.location.pathname.replace('/', '');
	  console.log(pathName)
	}
}
